import axios from 'axios';
import { env, extractJsonfromZip } from '../../utils/functions';

export const getBackofficeConfig = async (
  flowName: string,
  language: string,
  brand: string,
  isPreviewOn: boolean = false,
  envBO?: string
) => {
  //if (flowName && language && brand) {
  // implementare chiamata per recuperare il flusso configurato a BO
  const baseUrl =
    envBO === 'qa'
      ? process.env.REACT_AKAMAI_BO_BASE_URL_QA
      : process.env.REACT_AKAMAI_BO_BASE_URL;
  const environment = env(); //process.env.REACT_APP_ENVIRONMENT_URL;

  const AKAMAI_FLOW_URL_BASE_URL = `${baseUrl}/${brand.toLowerCase()}/${isPreviewOn ? 'draft' : environment}/${language}`;
  if (isPreviewOn) {
    try {
      if (!flowName) throw 'Missing flowname';
      const response = await axios.get(
        `${AKAMAI_FLOW_URL_BASE_URL}/${flowName}.json`
      );
      return response.data;
    } catch (e) {
      console.log('RXC3 | PREVIEW - Erorr: ', e);
    }
  } else {
    try {
      if (!flowName) throw 'Missing flowname';
      const response = await axios.get(
        `${AKAMAI_FLOW_URL_BASE_URL}/${flowName}.json`
      );
      return response.data;
    } catch (e) {
      try {
        const response = await axios.get(
          `${AKAMAI_FLOW_URL_BASE_URL}/default.json`
        );
        return response.data;
      } catch (e) {
        try {
          const { default: flow } = await import(
            `../../flow/${brand.toLowerCase()}/${language.toLowerCase()}/${flowName}.js`
          );
          return flow;
        } catch (e) {
          try {
            const { default: flow } = await import(
              `../../flow/${brand.toLowerCase()}/${flowName}.js`
            );
            return flow;
          } catch (e) {
            try {
              const { default: flow } = await import(
                `../../flow/${brand.toLowerCase()}/${language.toLowerCase()}/default.js`
              );
              return flow;
            } catch (e) {
              const { default: flow } = await import(
                `../../flow/${brand.toLowerCase()}/default.js`
              );
              return flow;
            }
          }
        }
      }
    }
  }
  //} else {
  //TODO Return default for RXC3, without brand
  //return undefined;
  //}

  // mock flusso in locale

  // impostare il flowName corrispondente nel config object in mock/${brand}.js oppure nell'url "http://localhost:3000/?flowName=GL_SUN_01"

  // const { default: flow } = await import(
  //   /* webpackChunkName: "[request]" */
  //   `../../flow/${channel}`
  // );
  // return flow;
};

export const getLensesDataContent = (url, onSuccess) => {
  axios
    .get(url, {
      responseType: 'arraybuffer',
      decompress: true,
    })
    .then((res) => {
      extractJsonfromZip(res.data, onSuccess);
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getLensesDataPackages = (url, onSuccess) => {
  axios
    .get(url, {
      responseType: 'arraybuffer',
      decompress: true,
    })
    .then((res) => {
      extractJsonfromZip(res.data, onSuccess);
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getLensesDataPrices = (url, onSuccess) => {
  axios
    .get(url)
    .then((res) => {
      onSuccess(res.data);
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getFrameRxValues = (url, onSuccess) => {
  axios
    .get(url)
    .then((res) => {
      onSuccess(res.data);
    })
    .catch((e) => {
      console.log(e);
    });
};
